export class InvoicingControlDtoModel {
	Id: number;
	Name: string;
	RecordsAmount: number;
}